import Request from "../../Platform/Request";

interface ServerUser {
    id: string;
    name: string;
    username: string;
    email: string;
    phone: string;
    image: string;
}

export function getUserFromServer(id: string): Promise<ServerUser> {
    return Request.get("/graphql", {
        params: {
            query: `
                query GetUser($id: ID!) {
                    user(id: $id) {
                        id,
                        name,
                        username,
                        email,
                        phone,
                        image
                    }
                }
            `,
            variables: {
                id,
            },
        },
    })
        .then(response => {
            if(response.data.errors) {
                throw response.data.errors;
            }

            return response.data.data.user;
        });
}
